import { Grid, makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import Organization from "../../actions/organization";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import UploadImage from "../../actions/uploadImage";
import { Image_API } from "../../config";

const initialFValues = {
  organization_name: "",
  phoneNo: "",
  address: "",
  email: "",
  profilePicture: null,
  editing: false,
};

const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));

const AddOrganization = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setOrganization,
  edite,
}) => {
  const classes = useStyles();
  const [file, setfile] = useState(null);
  const firstFieldRef = useRef(null);

  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("organization_name" in fieldValues)
      temp.organization_name =
        fieldValues.organization_name.length !== 0
          ? ""
          : "This field is required.";
    if ("phoneNo" in fieldValues)
      temp.phoneNo =
        fieldValues.phoneNo.length !== 0 ? "" : "This is required.";
    if ("email" in fieldValues) {
      if (fieldValues?.email?.length !== 0) {
        temp.email = regexEmail.test(fieldValues.email.toString().toLowerCase())
          ? ""
          : "Email is not valid.";
      } else {
        temp.email = "";
      }
    }
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const { addOrganization, updateOrganization } = Organization();
  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);
  const { uploadImage } = UploadImage();
  const handleImageChange = (e) => {
    const { files } = e.target;
    if (files.length > 0) {
      const selectedFile = files[0];
      setfile(URL.createObjectURL(selectedFile));
      setValues({ ...values, profilePicture: selectedFile });
    }
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (values.profilePicture instanceof File) {
      formData.append("image", values.profilePicture);
    }
    Object.keys(values).forEach((key) => {
      if (key !== "profilePicture") {
        formData.append(key, values[key]);
      }
    });

    if (validate()) {
      setValues({ ...values, submitting: true });

      if (recordForEdit === null) {
        try {
          if (values.profilePicture) {
            const data = await uploadImage(formData, "organization");
            if (data.err) {
              NotifyMessage({ message: data.err, type: "error" });
              setValues({ ...values, submitting: false });
              return;
            }
            values.profilePicture = data.data.data;
          }
          const addData = await addOrganization(values);
          if (addData.err) {
            NotifyMessage({ message: addData.err, type: "error" });
          } else {
            NotifyMessage({
              message: "Organization successfully created",
              type: "success",
            });
            setOpenPopup(false);
            setOrganization(
              produce((draft) => {
                draft.unshift({ ...addData.organization });
              })
            );
            resetForm();
          }
        } catch (error) {
          NotifyMessage({
            message: "Failed to create organization!",
            type: "error",
          });
        }
      } else {
        try {
          if (values.profilePicture instanceof File) {
            const uploadResponse = await uploadImage(formData, "organization");
            if (uploadResponse.err) {
              NotifyMessage({ message: uploadResponse.err, type: "error" });
              setValues({ ...values, submitting: false });
              return;
            }
            values.profilePicture = uploadResponse.data.data;
          } else {
            values.profilePicture = recordForEdit.profilePicture;
          }

          const updateData = await updateOrganization(values, values.id);
          if (updateData.err) {
            NotifyMessage({ message: updateData.err, type: "error" });
          } else {
            NotifyMessage({
              message: "Organization successfully updated",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
            setOrganization(
              produce((draft) => {
                const index = draft.findIndex(
                  (org) => org.id === recordForEdit.id
                );
                if (index !== -1) draft[index] = updateData.organization;
              })
            );
          }
        } catch (error) {
          NotifyMessage({
            message: "Failed to update organization!",
            type: "error",
          });
        }
      }
      setValues({ ...values, submitting: false });
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="organization_name"
            label="Organization Name"
            value={values.organization_name}
            onChange={handleInputChange}
            error={errors.organization_name}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="email"
            label="Email"
            value={values.email}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="phoneNo"
            label="Phone Number"
            value={values.phoneNo}
            onChange={handleInputChange}
            error={errors.phoneNo}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="address"
            label="Address"
            value={values.address}
            onChange={handleInputChange}
            error={errors.address}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <div className="flex space-x-3 items-center">
            {file ? (
              <img className={classes.icon} src={file} alt="Profile Preview" />
            ) : (
              <img
                className={classes.icon}
                src={`${Image_API}/${recordForEdit?.profilePicture}`}
                alt="Profile Preview"
              />
            )}
            <Controls.Input
              name="profilePicture"
              type="file"
              label="Image"
              onChange={handleImageChange}
              autoFocus={true}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6}/>
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite === true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddOrganization;
